const CLIENTE = 'C'
const PROVEEDOR = 'P'
const OTROS = 'O'

const __dictionary = {
  [CLIENTE]: {
    id: CLIENTE,
    nombre: 'CLIENTE'
  },
  [PROVEEDOR]: {
    id: PROVEEDOR,
    nombre: 'PROVEEDOR'
  },
  [OTROS]: {
    id: OTROS,
    nombre: 'OTROS'
  }
}

const __array = [__dictionary[CLIENTE], __dictionary[PROVEEDOR], __dictionary[OTROS]]

const __arrayCP = [__dictionary[CLIENTE], __dictionary[PROVEEDOR]]

export default Object.freeze({
  CLIENTE,
  PROVEEDOR,
  OTROS,
  __dictionary,
  __array,
  __arrayCP
})
